<template>
  <div>
    <el-row class="bottom20">
      <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
        <el-table-column prop="customerName">
          <template slot="header" slot-scope="scope">
            客户名称<br>
            <!--<el-input size="mini" v-model="pageSearch.search.like_customerName" placeholder="客户名称"></el-input>-->
            <customer-select v-model="pageSearch.search.eq_customerId"
                             @change="pageSearch.search.eq_id = null" :filterable="true" :clearable="true"
                             size="mini">
            </customer-select>
          </template>
          <template slot-scope="scope">
            {{scope.row.customerName}}
          </template>
        </el-table-column>

        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            合同名称<br>
            <!--<el-input size="mini" v-model="pageSearch.search.like_name" placeholder="合同名称"></el-input>-->
            <contract-select v-model="pageSearch.search.eq_id"
                             :customer-id="pageSearch.search.eq_customerId" :filterable="true" :clearable="true"
                             size="mini">
            </contract-select>
          </template>
          <template slot-scope="scope">
            <a href="javascript: void(0);" @click.self="toDetailTab(scope.row)">{{scope.row.name}}</a>
          </template>
        </el-table-column>

        <el-table-column prop="sid">
          <template slot="header" slot-scope="scope">
            合同编号<br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.sid}}
          </template>
        </el-table-column>

        <el-table-column prop="roomIdArray">
          <template slot="header" slot-scope="scope">
            所属数据中心<br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope">
            <span v-for="roomId in scope.row.roomIds" :key="roomId">
              <dictionary-text :factory-name="'room'" :params="{type: 'ALL'}" :value="roomId"></dictionary-text><br/>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="serviceLevel" width="120px">
          <template slot="header" slot-scope="scope">
            开始日期<br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.startTs | dateFormat('yyyy-MM-dd')}}
          </template>
        </el-table-column>

        <el-table-column prop="customerType" width="120px">
          <template slot="header" slot-scope="scope">
            结束日期<br>
            <div style="height: 28px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.endTs | dateFormat('yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column prop="status">
          <template slot="header" slot-scope="scope">
            状态<br>
            <dictionary-select v-model="pageSearch.search.in_workflowStatus" :multiple="true" :clearable="true" :collapse-tags="true"
                               :factory-name="'domain'" :params="'BCWSTATUS'" size="mini">
            </dictionary-select>
          </template>
          <template slot-scope="scope">
            <span>
              <span v-if="scope.row.workflowStatus == null">-</span>
              <dictionary-text v-else :factory-name="'domain'" :params="'BCWSTATUS'" :value="scope.row.workflowStatus" size="mini"></dictionary-text>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
  import {merge} from "@/util"
  import _ from 'lodash'
  import Emitter from 'element-ui/src/mixins/emitter'
  import {formatDate} from 'element-ui/lib/utils/date-util'

  import {AuthInfo} from '@/util/user/authInfo'

  import DictionaryText from '@/components/common/DictionaryText'
  import CustomerSelect from '@/views/billing/customer/component/customer.select'
  import ContractSelect from '@/views/billing/contract/component/contract.select'

  import BillingServer from  '@/api/billing'

  import {dictionaryContainer} from '@/util/common/dictionary'

  import { WorkflowApiNew } from '@/api/workflow/workflow'

  import {
    COMPONENT_MAIN, COMPONENT_LIST, FN_LIST_QUERY, FN_TO_DETAIL_SHOW
  } from "./contract.common"
  import DictionarySelect from "../../../components/common/DictionarySelect";

  export default {
    name: COMPONENT_LIST,
    componentName: COMPONENT_LIST,
    mixins: [Emitter],
    components: {
      DictionarySelect,
      DictionaryText, CustomerSelect, ContractSelect
    },
    props: {
      search: {},
    },
    data() {
      return {
        key: 'id',
        currentRowData: null,
        visited: [],
        pageSearch: {
          current: 1,
          size: 10,
          search: {
            like_customerName: null,
            eq_customerId: null,
            like_name: null,
            eq_id: null,
            in_id: null,
            isAuthUserIds: true,
            currentUserId: AuthInfo.userId,
            isAuthRoomIds: false,
            authRoomIds: [],
            eq_flag: null,
            in_workflowStatus: [],
          },
        },
        page: {
          total: 0,
          records: []
        },
      };
    },
    computed: {
    },
    watch: {
      search: {
        deep: true,
        immediate: true,
        handler() {
          this.pageSearch.search = merge(true, {}, this.pageSearch.search, this.search);
        }
      },
      'pageSearch.current': {
        deep: false,
        handler() {
          this.queryByPage();
        },
      },
      'pageSearch.size': {
        deep: false,
        handler() {
          this.reQueryByPage();
        },
      },
      'page': {
        deep: true,
        handler(value) {
          if (value.total > 0) {
            let record;
            let records = value.records;
            if (this.currentRowData != null && this.currentRowData[this.key] != null) {
              for (let i = 0, l = records.length; i < l; i++) {
                if (this.currentRowData[this.key] === records[i][this.key]) {
                  record = records[i];
                  break;
                }
              }
            }
            if (record == null) {
              record = records[0];
            }
            this.select(record);
          }
        },
      },
      'pageSearch.search': {
        deep: true,
        handler(value) {
          this.reQueryByPage();
          if (value != null) {
            this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
          }
        }
      }
    },
    methods: {
      handleCurrentChange(current) {
        this.pageSearch.current = current;
      },
      handleSizeChange(size) {
        this.pageSearch.size = size;
      },
      reQueryByPage() {
        if (this.pageSearch.current === 1) {
          this.queryByPage();
        } else {
          this.pageSearch.current = 1;
        }
      },
      queryByPage: _.debounce(async function() {
        let roomDictionary = await dictionaryContainer.getDictionary('room', {type: 'AUTH_SITE'});
        let authRoomIds;
        let roomIds = roomDictionary.getValues();
        if (roomIds == null || roomIds.length <= 0) {
          authRoomIds = [];
        } else {
          authRoomIds = roomIds;
        }
        let pageSearch = _.merge(this.pageSearch, {
          search: {
            authRoomIds: authRoomIds
          }
        });
        let source = this.$route.query.source;
        if (source != null && source === 'index' && pageSearch.search.in_id == null) {
          let result = await WorkflowApiNew.fetchCurrentTaskIds('CONTRACT');
          pageSearch.search.in_id = result.data;
          this.pageSearch.search.in_id = result.data;
        }
        BillingServer.contract.page(pageSearch).then((res) => {
          if (String(res.data.code) === '200' || res.data.success) {
            let records = res.data.data.records;
            records.forEach(record => {
              let roomIdsStr = record.roomIds;
              let roomIds = [];
              if (roomIdsStr != null && roomIdsStr.trim() !== '') {
                let roomIdStrings = roomIdsStr.split(',');
                roomIdStrings.forEach(roomIdString => {
                  let roomId = null;
                  try {
                    roomId = parseInt(roomIdString.trim());
                  } catch (e) {
                    window.console.error(e);
                  }
                  if (roomId != null) {
                    roomIds.push(roomId);
                  }
                });
              }
              record.roomIds = roomIds;
            });
            this.page = {
              total: res.data.data.total,
              records: records,
            };
          }
        });
      }) ,
      query() {
        this.queryByPage();
      },
      reQuery() {
        this.reQueryByPage();
      },
      select(data) {
        this.currentRowData = data;
      },
      getSelectedCellClassName({row}) {
        let cellClassName = '';
        if (this.currentRowData && this.currentRowData[this.key] === row[this.key]) {
          cellClassName += ' currentAccess ';
        }
        return cellClassName;
      },
      visit(data) {
        let id = data[this.key];
        if (this.visited.indexOf(id) === -1) {
          this.visited.push(id);
        }
      },
      getVisitedRowClassName({row}) {
        let rowClassName = '';
        if (this.visited.indexOf(row[this.key]) !== -1) {
          rowClassName += ' visited';
        }
        return rowClassName;
      },
      toDetailTab(data) {
        this.select(data);
        this.visit(data);
        this.dispatch(COMPONENT_MAIN, FN_TO_DETAIL_SHOW, data);
      },
    },
    mounted() {
    },
    filters: {
      dateFormat: (value, format = 'yyyy-MM-dd') => {
        return value == null ? '' : formatDate(new Date(value), format);
      }
    }
  }
</script>

<style scoped>

</style>
